module.exports = "pegasus_template/assets/blocks/column-1-theme2.png";